import React from 'react'
import withData from './withData'
import {compose} from 'recompose'
import CustomSelect from './CustomSelect'

const BooleanSelect = compose(
  withData({
    data: [{key: true, value: 'Yes'}, {key: false, value: 'No'}],
  }),
)(CustomSelect)

export default BooleanSelect
